import { FormControl } from "@angular/forms";
import { Firma_Electronica_CamposAdicionalesDatos } from "./Firma_Electronica_CamposAdicionalesDatos";

export class Firma_Electronica_CamposAdicionales {
    id: number;
    codigoCampo: string;
    descripcionCampo: string;
    tipoCampo: string;
    campoFormulario: FormControl;
    datosConfiguracion: string;
    listaDatosCompleta: Firma_Electronica_CamposAdicionalesDatos[] = [];
    listaDatos: Firma_Electronica_CamposAdicionalesDatos[] = [];
    codigoCampoDependiente: string;
}